const translation_table = {
  text_state_scan: "Statistics for scanning in and out",
  text_std_total: "Total number of students",
  text_scan_in: "Scan In",
  text_no_scan: "No Scan",
  text_scan_out: "Scan out",
  text_scan_late: "Late",
  text_scan_befor: "Befor",
  press_release: "Press release",
  system_text: "System",
  menu_text: "Menu",

  text_check_row: "Student check",
  text_check_homeroom: "Homeroom",
  text_advisee: "Advisee",
  text_document: "Documents",
  text_behavior: "Behavior",
  text_visithome: "Visit home",
  text_sdq: "SDQ",

  text_check_time: "Check time",
  text_timetable: "Time table",
  text_homework: "Homework",
  text_activitie: "Activitie",
  text_others: "Others",
  text_report: "Report",

  menu_goverment_main: "Goverment",
  menu_academic_main: "Academic",
  menu_evoluation_main: "Evoluation",
  menu_registration_main: "Registration",
  menu_advertise_main: "Advertise",
  menu_person_main: "Person",
  menu_medical_main: "Medical",
  menu_setting_main: "setting",

  ///////////////////////////////////////////////
  text_check_row_homeroom: "Student check/Homeroom",
  text_check_sts_checked: "Checked",
  text_check_sts_notchecked: "Not checked",
  text_check_sts_present: "Present",
  text_check_sts_absent: "Absent",
  text_check_sts_per1: "",
  text_check_sts_per2: "% of the total",
  text_check_sts_per3: "%",
  text_check_sts_forgot_card1: "Forgot Card",
  text_check_sts_forgot_card2: "",
  text_check_date: "Check date",
  text_check_classRoom: "Class room",
  text_check_ok: "OK",
  text_check_view_report: "View report",
  text_check_no: "No.",
  text_check_student_id: "Student ID",
  text_check_student_name: "Name",
  text_check_time_in: "Time in",
  text_check_status: "Status",
  text_check_save: "Save",
  text_check_back: "Back",
  text_check_cancel: "Cancel",
  text_check_timeout: "Timeout to save row check",
  text_check_not_have_student:
    " You do not have student information in your advisor",
  text_check_homeroom_content: " Homeroom content",

  ///////////////////////////////////////////////
  text_consult_date: "Date",
  text_classRoom: "Class room",
  text_view_registration: "View registration",
  text_behavior_score: "Behavior score",
  text_behavior_scan_in: "Scan in",
  text_behavior_scan_out: "Scan out",

  text_home: "Home",
  text_sex_man: "Men",
  text_sex_woman: "Women",

  menu_registration_studentinfo: "Student info",
  menu_registration_class: "Class room",
  menu_registration_doc: "Document",
  menu_financial_main: "Finance",
  menu_registration_new_card: "คำร้องทำบัตรใหม่",

  menu_library_main: "Library",

  btn_back: "Back",
  btn_save: "Save",
  btn_cancel: "Cancel",
  btn_submit: "Submit",

  form_ids_text: "",
  form_prefix_text: "",
  form_fname_text: "",
  form_lname_text: "",
  form_stdno_text: "",
  form_birthday_text: "",
  form_mobile_text: "",
  form_email_text: "",
  form_sex_text: "",


  //////////// สรรหามาเล่า rotary//////////////

  //สว่น login และ register
  login_title: "Login",
  login_button: "Login",
  input_username: "Username",
  span_username: "Please enter your username",
  input_password: "Password",
  span_password: "Please enter your password",

  show_password: "Show/Hide Password",
  remamber_me: "Remember me",

  auth_hero_title: "Creating Good Together",
  auth_hero_subtitle: "For Communities, Society, and the World",
  auth_hero_description: "Rotary is a network of leaders and people of action who work together to create lasting change in communities and around the world.",


  // คู่มือ

  manual_title: "System user manual",
  button_close: "Close",


  register_title: "Register",
  register_button: "Register",
  input_name: "First Name",
  span_name: "Please enter your first name",
  input_lastname: "Last Name",
  span_lastname: "Please enter your last name",
  input_confirm_password: "Confirm Password",
  span_confirm_password: "Please enter your confirm password",
  have_account: "Have an account already? ",
  not_have_account: "Don't have an account yet? ",


  //ส่วนหัวสุด
  name_website: "Rotary Storytelling",
  profile_button: "Profile",
  logout_button: "Logout",

  // ส่วนค้นหาโพส
  search_placeholder: "Search by author or keywords",
  search_button: "Search",
  search_hint: "Search by author or filter posts in your feed",
  author: "Author",
  all: "All",
  filters: "Filters",
  filter_all: "All",
  filter_following: "Following only",
  filter_saved: "Saved posts",
  post_placeholder: "Post",
  post_button: "Post",


  ///////////// กล่องส่วนที่สร้างโพส //////////////
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
  link: "Link",
  image: "Image",
  video: "Video",

  save_button: "Save",
  cancel_button: "Cancel",
  update_button: "Update",
  close_button: "Close",


  title_create_video: "Paste Video URL and press Enter before posting",
  span_create_video: "Supports YouTube / Facebook / TikTok (paste link and press Enter)",


  //////////// กล่องเขียนคอมเมนต์ //////////////
  follow_button: "Follow Author",
  save_post_button: "Save Post",
  edit_post_button: "Edit Post",
  delete_post_button: "Delete Post",

  hide_text: "Hide",
  show_text: "Show More",

  reply: "Reply",
  cancel: "Cancel",

  send: "Send",
  edit_comment_title: "Edit comment...",
  delete_comment_title: "Delete comment",
  comment_placeholder: "Write a comment...",


  //////// models แก้ไขรูปภาพ ////////////
  title_edit_image: "Edit uploaded image",
  span_edit_image: "No uploaded image",
  span_edit_image2: "Tap the image to upload a new profile image",
  back_profile: "Back to profile",


  //////// แก้ไขข้อมูลส่วนตัว ////////////
  displayname: "Display Name",
  email: "Email",
  span_email: "Please enter your email",
  saving: "Saving...",
  save_success: "Save success",
  reset: "Reset",
  text_post: "Posts",
  text_follower: "Followers",
  text_following: "Following",
  text_account: "Account",
  text_edit_profile: "Edit Profile",
  text_edit_cover: "Edit Cover Photo",
};
export default translation_table;
